export default "__VITE_ASSET__hGthV3CkjdLGKa7gMzLO7w__"